export const BaseUrl = "https://careerswebapi.sishipping.com:1110/api";
export const Login = "/authenticate/login";
export const Ranks = "/home/get-all-ranks";
export const Officers = "/home/get-ranks-and-sourcing-officer-details"